import {Action, ActionHackCtx, IAction} from "lib/commons/actions";
import {IReg, IRegPointer, REG} from 'lib/commons/registry';
import {JSX} from "lib/commons/xml/dom";
import "back/core/plugins/plugins_Perms";
import {ICoreUniverseEnv} from "lib/core/universe";
import {POPUP} from "back/commons/widgets/popups";
import {OUsersMgrInit} from "back/core/dialogs/usersMgr";
import {EUserAspects} from "lib/core/user";
import {ORolesExplorerInit} from "back/core/dialogs/rolesExplorer";


/**
 * Gestionnaire des utilisateurs
 *
 * @param reg Registre à exploiter correspondant
 */
export function initApp(reg: IReg<ICoreUniverseEnv> = REG.reg) {

	class WrapReg extends ActionHackCtx<Element, IReg<ICoreUniverseEnv>> {
		constructor(sub: IAction<IReg<ICoreUniverseEnv>>, public reg: IReg<ICoreUniverseEnv>) {
			super(sub);
		}

		wrapCtx(ctx: Element): IReg<ICoreUniverseEnv> {return this.reg}

		initButtonNode(buttonNode: Element, ctx: Element) {
			//Affectation du bon registre dans le contexte graphique.
			(buttonNode as IRegPointer<ICoreUniverseEnv>).reg = this.reg;
			this.sub.initButtonNode(buttonNode, this.reg);
		}
	}

	function wrap(action: IAction<IReg<ICoreUniverseEnv>>): IAction<Element> {
		return new WrapReg(action, reg);
	}

	//Menu Options
	REG.reg.addToList("appframe:header:toolbar:params", "users", 1, wrap(new OpenUsersMgr().requireVisiblePerm("ui.usersPlg.users")), 100);
	REG.reg.addToList("appframe:header:toolbar:params", "groups", 1, wrap(new OpenGroupsMgr().requireVisiblePerm("ui.usersPlg.groups")), 101);
	REG.reg.addToList("appframe:header:toolbar:params", "roles", 1, wrap(new OpenRolesExplorer().requireVisiblePerm("ui.usersPlg.rolesExplorer")), 200);

}

/**
 * Ouverture du gestionnaire des utilisateurs
 */

export class OpenUsersMgr extends Action<IOpenUsersMgrCtx> {

	constructor() {
		super("usersMgr");
		this._label = "Gestion des utilisateurs...";
		this._group = 'users';
		this._icon = '/@skin@/core/objects/user.svg';
	}

	async execute(ctx: IOpenUsersMgrCtx, ev?: Event) {
		const MOD = await import("back/core/dialogs/usersMgr.js");
		const ct = new MOD.UsersMgr().initialize({
			reg: ctx.reg,
			uiContext: "popup",
			preSelectAccount: ctx.preSelectAccount,
		} as OUsersMgrInit);
		await POPUP.showDialog(ct, null, {
			titleBar: {barLabel: {label: "Gestion des utilisateurs"}, closeButton: {}},
			resizer: {},
			initWidth: "max(80vw,50em)",
			initHeight: "90vh"
		}).onNextClose();
	}

	isVisible(ctx: IOpenUsersMgrCtx): boolean {
		if (!ctx.reg.env.universe.adminUsers) return false;
		return super.isVisible(ctx);
	}

	isEnabled(ctx: IOpenUsersMgrCtx): boolean {
		//if (!Desk.checkCompat('formElt')) return false;
		return super.isEnabled(ctx);
	}

	// getDescription(ctx: IReg<ICoreUniverseEnv>): string {
	// 	if (!Desk.checkCompat('formElt')) return "Ce navigateur n'est pas compatible avec cette fonction";
	// }

}

export interface IOpenUsersMgrCtx extends IReg<ICoreUniverseEnv> {
	preSelectAccount?: string
}


/**
 * Ouverture du gestionnaire des groupes
 */
export class OpenGroupsMgr extends Action<IOpenUsersMgrCtx> {

	constructor() {
		super("usersMgr");
		this._label = "Gestion des groupes...";
		this._group = 'users';
		this._icon = '/@skin@/core/objects/group.svg';
	}

	async execute(ctx: IOpenUsersMgrCtx, ev?: Event) {
		const MOD = await import("back/core/dialogs/usersMgr.js");
		const ct = new MOD.GroupsMgr().initialize({
			reg: ctx.reg,
			uiContext: "popup",
			preSelectAccount: ctx.preSelectAccount,
		} as OUsersMgrInit);
		await POPUP.showDialog(ct, null, {
			titleBar: {barLabel: {label: "Gestion des groupes"}, closeButton: {}},
			resizer: {},
			initWidth: "min(90vw,40em)",
			initHeight: "90vh"
		}).onNextClose();
	}

	isVisible(ctx: IOpenUsersMgrCtx): boolean {
		if (!ctx.reg.env.universe.adminUsers || !ctx.reg.env.universe.adminUsers.hasAspect(EUserAspects.groupable)) return false;
		return super.isVisible(ctx);
	}

	isEnabled(ctx: IOpenUsersMgrCtx): boolean {
		//if (!Desk.checkCompat('formElt')) return false;
		return super.isEnabled(ctx);
	}

	// getDescription(ctx: IReg<ICoreUniverseEnv>): string {
	// 	if (!Desk.checkCompat('formElt')) return "Ce navigateur n'est pas compatible avec cette fonction";
	// }

}


/**
 * Ouverture de l'explorateur des rôles
 */
export class OpenRolesExplorer extends Action<IReg<ICoreUniverseEnv>> {

	constructor() {
		super("usersMgr");
		this._label = "Explorateur des rôles...";
		this._description = "Explorateur des rôles affectés des utilisateurs sur les différents composants applicatifs";
		this._group = 'users';
	}

	async execute(ctx: IReg<ICoreUniverseEnv>, ev?: Event) {
		const MOD = await import("back/core/dialogs/rolesExplorer.js");
		const ct = new MOD.RolesExplorer().initialize({
			reg: ctx.reg,
			uiContext: "popup",
		} as ORolesExplorerInit);
		await POPUP.showDialog(ct, null, {
			titleBar: {barLabel: {label: "Explorateur des rôles"}, closeButton: {}},
			resizer: {},
			initWidth: "min(90vw,100em)",
			initHeight: "90vh"
		}).onNextClose();
	}

	isVisible(ctx: IReg<ICoreUniverseEnv>): boolean {
		if (!ctx.reg.env.universe.adminUsers) return false;
		return super.isVisible(ctx);
	}

	isEnabled(ctx: IReg<ICoreUniverseEnv>): boolean {
		//if (!Desk.checkCompat('formElt')) return false;
		return super.isEnabled(ctx);
	}

}